import { Component, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EntityFormComponent } from 'app/components/entity-form/entity-form.component';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { EmployeeService } from 'app/modules/vehicle-inventory/services/employee.service';
import { BillingaccountService } from 'app/rest/billingaccount.service';
import { CecoService } from 'app/rest/ceco.service';
import { DivisionService } from 'app/rest/division.service';
import { Rest } from 'app/rest/rest_client';
import { SubdivisionService } from 'app/rest/subdivision.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';

@Component({
  selector: 'app-employee-form',
  templateUrl: './employee-form.component.html',
  styleUrls: ['./employee-form.component.css'],
  providers:[BillingaccountService, CecoService, DivisionService, SubdivisionService]
})
export class EmployeeFormComponent extends EntityFormComponent<Rest.InvEmployee>
implements OnInit{

  isSaveGranted: boolean;
  title: string;
  billingAccountRequestContext:Rest.ListPaginationRequest;
  billingAccountList: Rest.BillingAccount[];
  selectedBillingAccount: Rest.BillingAccount;
  cecoRequestContext: Rest.ListPaginationRequest;
  cecoList: Rest.Ceco[];
  selectedCeco: Rest.Ceco;
  divisionRequestContext: Rest.ListPaginationRequest;
  divisionList: Rest.Division[];
  selectedDivision: Rest.Division;
  subDivisionRequestContext:Rest.ListPaginationRequest;
  subDivisionList: Rest.Subdivision[];
  selectedSubDivision: Rest.Subdivision;

  constructor(
    private employeeService: EmployeeService,
    notificationsService: NotificationsService,
    protected i18n: I18nService,
    private authenticationService: AuthenticationService,
    public translateService: TranslateService,
    private userTime: UserTimePipe,
    protected billingAccountService: BillingaccountService,
    protected cecoService: CecoService,
    protected divisionService: DivisionService,
    protected subDivisionService: SubdivisionService
) {
    super(employeeService, notificationsService, i18n, authenticationService);
}

ngOnInit() {
    super.ngOnInit();

    this.setPermissions();

}

protected beforeShow(): void {
  this.selectedBillingAccount = null;
  this.selectedCeco = null; 
  this.selectedDivision = null;
  this.selectedSubDivision = null;
  this.billingAccountRequestContext = {
    sortBy: 'code',
    sortAsc: true,
    pageSize: 10,
    filters: {},
    loadPermissions: false,
  } as Rest.ListPaginationRequest;

  this.cecoRequestContext = {
    sortBy: 'code',
    sortAsc: true,
    pageSize: 10,
    filters: {},
    loadPermissions: false,
  } as Rest.ListPaginationRequest;

  this.divisionRequestContext = {
    sortBy: 'code',
    sortAsc: true,
    pageSize: 10,
    filters: {},
    loadPermissions: false,
  } as Rest.ListPaginationRequest;

  this.subDivisionRequestContext = {
    sortBy: 'code',
    sortAsc: true,
    pageSize: 10,
    filters: {},
    loadPermissions: false,
  } as Rest.ListPaginationRequest;

  this.billingAccountRequestContext.filters["clientID"] = [this.authenticationService.user.client.id.toString()];
  
  if (this.isNew) {
    this.title = this.translateService.instant('tableManagement.employee.createEmployee');


  }else{
    this.title = this.translateService.instant('tableManagement.employee.updateEmployee');

    if(this.entity.ceco?.billingAccount){
      this.billingAccountRequestContext.filters['name'] = [this.entity.ceco.billingAccount.name];
      this.selectedBillingAccount = this.entity.ceco.billingAccount;
    }

    if(this.entity.ceco){
      this.cecoRequestContext.filters['billingAccount'] =[this.entity.ceco.billingAccount.id.toString()];
      this.selectedCeco = this.entity.ceco;
    }

    if(this.entity.subdivision?.division){
      this.divisionRequestContext.filters['name'] = [this.entity.subdivision.division.name];
      this.selectedDivision = this.entity.subdivision.division;
    }

    if(this.entity.subdivision){
      this.subDivisionRequestContext.filters['divisionId'] = [this.entity.subdivision.division.id.toString()];
      this.selectedSubDivision = this.entity.subdivision;
    }
  }

  this.billingAccountService.getPage(this.billingAccountRequestContext).then((p) => {
    this.billingAccountList = p.entities.map((billingAccount) =>({
      ...billingAccount,
      formatBillingAccountLabel: `(${billingAccount.code}) ${billingAccount.name}`,
    }));
  });

  this.cecoService.getPage(this.cecoRequestContext).then((p) => {
    this.cecoList = p.entities.map((ceco) =>({
      ...ceco,
      formatCecoLabel: `(${ceco.code}) ${ceco.description}`,
    }));
  });

  this.divisionService.getPage(this.divisionRequestContext).then((p) => {
    this.divisionList = p.entities.map((division) =>({
      ...division,
      formatDivisionLabel: `(${division.code}) ${division.name}`,
    }));
  });

  this.subDivisionService.getPage(this.subDivisionRequestContext).then((p) => {
    this.subDivisionList = p.entities.map((subDivision) =>({
      ...subDivision,
      formatSubDivisionLabel: `(${subDivision.code}) ${subDivision.name}`,
    }));
  });

}

setPermissions() {
  const user = this.authenticationService.user;
  const rolesForForm = ['INV_EMPLOYEE_CREATE', 'INV_EMPLOYEE_UPDATE'];


  this.isSaveGranted = this.authenticationService.isOneRoleGranted(rolesForForm, user);
}

changeName(event) {

  if(!this.entity.user){
    this.entity.user = {} as Rest.User;
  }
  this.entity.user.name = event.target.value;
}

changeSurname1(event) {

  if(!this.entity.user){
    this.entity.user = {} as Rest.User;
  }
  this.entity.user.surname1 = event.target.value;
}

changeSurname2(event) {

  if(!this.entity.user){
    this.entity.user = {} as Rest.User;
  }
  this.entity.user.surname2 = event.target.value;
}

changeBirthDate(event) {

  if(!this.entity.user){
    this.entity.user = {} as Rest.User;
  }
  this.entity.user.birthDate = event.target.value;
}

changeCp(event) {

  if(!this.entity.user){
    this.entity.user = {} as Rest.User;
  }
  this.entity.user.cp = event.target.value;
}

changePopulation(event) {

  if(!this.entity.user){
    this.entity.user = {} as Rest.User;
  }
  this.entity.user.population = event.target.value;
}

changePhoneNumber(event) {

  if(!this.entity.user){
    this.entity.user = {} as Rest.User;
  }
  this.entity.user.phoneNumber = event.target.value;
}

changeAddress(event) {

  if(!this.entity.user){
    this.entity.user = {} as Rest.User;
  }
  this.entity.user.address = event.target.value;
}

saveDriver(): void {


  if(this.validateForm()){
    if(this.isNew){
      this.entity.user.userName = this.entity.nif + "_" + this.entity.code;
      this.entity.user.password = this.generateRandomString(10);
      this.entity.user.email = this.entity.professionalEmail;
      this.entity.user.metric = this.authenticationService.user.metric;
      this.entity.user.language = this.authenticationService.user.language;
      this.entity.user.timeZone = this.authenticationService.user.timeZone;
    }
  
    this.entity.ceco = this.selectedCeco;
    this.entity.subdivision = this.selectedSubDivision;
  
    if(this.entity.ceco){
      delete (this.entity.ceco as any).formatCecoLabel;
    }
  
    if(this.entity.subdivision){
      delete (this.entity.subdivision as any).formatSubDivisionLabel;
    }

    this.save();
  }else{
    this.notificationsService.add(
      Severity.error,
      this.translateService.instant(this.isNew ? 'general.createError' : 'general.updateError') + '!',
      this.translateService.instant('error.required-field.generic')
    );
  }

  
  
  


  
}

generateRandomString(length: number): string {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
}

onChangeBillingAccount(event) {
  this.selectedBillingAccount = event.value;
  this.selectedCeco = null;
  this.cecoRequestContext.filters['billingAccount'] = [this.selectedBillingAccount.id.toString()];
  this.cecoService.getPage(this.cecoRequestContext).then((p) => {
    this.cecoList = p.entities.map((ceco) => ({
      ...ceco,
      formatCecoLabel: `(${ceco.code}) ${ceco.description}`,
    }));
  });
}

onFilterBillingAccount(event) {

  this.billingAccountRequestContext.filters['fullName'] = [event.filter ?? ''];
  this.billingAccountService.getPage(this.billingAccountRequestContext).then((p) => {
    this.billingAccountList = p.entities.map((billingAccount) => ({
      ...billingAccount,
      formatBillingAccountLabel: `(${billingAccount.code}) ${billingAccount.name}`,
    }));
  });
}

onChangeCeco(event) {
  this.selectedCeco = event.value;
}

onFilterCeco(event) {
  this.cecoRequestContext.filters['billingAccount'] = [this.selectedBillingAccount.id.toString()];
  this.cecoRequestContext.filters['fullName'] = [event.filter ?? ''];
  this.cecoService.getPage(this.cecoRequestContext).then((p) => {
    this.cecoList = p.entities.map((ceco) => ({
      ...ceco,
      formatCecoLabel: `(${ceco.code}) ${ceco.description}`,
    }));
  });
}

onChangeDivision(event) {
  this.selectedDivision = event.value;
  this.selectedSubDivision = null;
  this.subDivisionRequestContext.filters['divisionId'] = [this.selectedDivision.id.toString()];
  this.subDivisionService.getPage(this.subDivisionRequestContext).then((p) => {
    this.subDivisionList = p.entities.map((subDivision) => ({
      ...subDivision,
      formatSubDivisionLabel: `(${subDivision.code}) ${subDivision.name}`,
    }));
  });
}

onFilterDivision(event) {

  this.divisionRequestContext.filters['fullName'] = [event.filter ?? ''];
  this.divisionService.getPage(this.divisionRequestContext).then((p) => {
    this.divisionList = p.entities.map((division) => ({
      ...division,
      formatDivisionLabel: `(${division.code}) ${division.name}`,
    }));
  });
}

onChangeSubDivision(event) {
  this.selectedSubDivision = event.value;
}

onFilterSubDivision(event) {
  this.subDivisionRequestContext.filters['divisionId'] = [this.selectedDivision.id.toString()];
  this.subDivisionRequestContext.filters['fullName'] = [event.filter ?? ''];
  this.subDivisionService.getPage(this.subDivisionRequestContext).then((p) => {
    this.subDivisionList = p.entities.map((subDivision) => ({
      ...subDivision,
      formatCecoLabel: `(${subDivision.code}) ${subDivision.name}`,
    }));
  });
}

validateForm(): boolean {
  if(!this.entity.code || !this.entity.user || !this.entity.user.name || !this.entity.nif || !this.entity.professionalEmail){
    return false;
  }
  return true;
}



}
